import React from 'react';

interface Props {
  screen: string;
  component: any;
}

export const Route: React.FC<Props> = ({ screen, component, ...props }) =>
  typeof component === 'function' ? component(props) : React.cloneElement(component, props);
